import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";

import EventList from "@/views/event/EventList.vue";
import EventDetails from "@/views/event/EventDetails.vue";
import EventCreate from "@/views/event/EventCreate.vue";

import ClientDocument from "@/views/client-document/ClientDocument.vue";

import CreditorDetails from "@/views/creditor/CreditorDetails.vue";
import CreditorList from "@/views/creditor/CreditorList.vue";

import PlanAdhesion from "@/views/plan-adhesion/PlanAdhesion.vue";

import RmaDocuments from "@/views/rma/RmaDocuments.vue";
import RmaHistory from "@/views/rma/RmaHistory.vue";
import RmaQuestionnaires from "@/views/rma/RmaQuestionnaires.vue";
import RmaQuestionnaireForm from "@/views/rma/RmaQuestionnaireForm.vue";

import * as jwt from "jwt-decode";

//the route guard
const guard = function (to: any, from: any, next: any) {
  const token = localStorage.getItem("token");

  // const checked = this.$check(to.name, 'GET');


  const publicPath = to.matched.find(
    (path) => path.name === "Public" || path.name === "Home"
  );
  if (!token && to.path !== "/login" && !publicPath) {
    next({
      path: "/login",
    });
  } else {

    console.log('to.name ', to.name)

    if (to.name == "Home") {
      next();
      return;
    }

    const resolvedToken = jwt(token);

    // const profile = adminProfiles.find((x) => x.id === resolvedToken.data.profile);

    // if(profile.permissions && profile.permissions[0] === '*') return next();

    // const checkPermission = profile.permissions.find((x) => x.path === to.name);

    // if(!checkPermission) {
    //   next({
    //     path: "/home",
    //   });
    //   return;
    // }

    // const checkMethod = checkPermission.method.includes('GET')

    // if(!checkMethod) {
    //   next({
    //     path: "/home",
    //   });
    //   return;
    // }

    next();
  }
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/Public.vue"),
    children: [
      {
        path: "/login",
        name: "login",
        component: Login,
      },
      // Link de envio do RMA sem login (o token e a credencial).
      {
        path: "/envio-rma/:token",
        name: "RmaShareUpload",
        component: () => import("@/views/rma/RmaShareUpload.vue"),
      },
      {
        path: "/",
        redirect: "/login",
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/Private.vue"),
    beforeEnter: guard,
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
        beforeEnter: guard,
      },
      {
        path: "/divergencias",
        name: "Event",
        component: EventList,
        beforeEnter: guard,
      },
      {
        path: "/divergencias/incluir",
        name: "Event",
        component: EventCreate,
        beforeEnter: guard,
      },
      {
        path: "/divergencias/:id",
        name: "Event",
        component: EventDetails,
        beforeEnter: guard,
      },
      {
        path: "/documentos-solicitados",
        name: "ClientDocument",
        component: ClientDocument,
        beforeEnter: guard,
      },
      {
        path: "/credores",
        name: "CreditorList",
        component: CreditorList,
        beforeEnter: guard,
      },
      {
        path: "/credores/:id", 
        name: "CreditorDetails",
        component: CreditorDetails,
        beforeEnter: guard,
      },
      {
        path: "/adesao-plano",
        name: "PlanAdhesion",
        component: PlanAdhesion,
        beforeEnter: guard,
      },
      {
        path: "/fiscalizacao-mensal",
        name: "RmaDocuments",
        component: RmaDocuments,
        beforeEnter: guard,
      },
      {
        path: "/fiscalizacao-mensal/historico",
        name: "RmaHistory",
        component: RmaHistory,
        beforeEnter: guard,
      },
      // Juridico: mesmas telas da fiscalizacao, com a area "legal".
      {
        path: "/juridico",
        name: "RmaDocuments",
        component: RmaDocuments,
        props: { track: "legal" },
        beforeEnter: guard,
      },
      {
        path: "/juridico/historico",
        name: "RmaHistory",
        component: RmaHistory,
        props: { track: "legal" },
        beforeEnter: guard,
      },
      {
        path: "/fiscalizacao-mensal/questionarios",
        name: "RmaQuestionnaires",
        component: RmaQuestionnaires,
        beforeEnter: guard,
      },
      {
        path: "/fiscalizacao-mensal/questionarios/:id",
        name: "RmaQuestionnaires",
        component: RmaQuestionnaireForm,
        beforeEnter: guard,
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
